module.exports = __webpack_public_path__ + "images/fixtures/map-tile.png";